var _defineProperty = require("@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _excluded = ["appendix8"],
  _excluded2 = ["system"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-underscore-dangle */

const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue,
  hasContentValue = _require.hasContentValue;
const _require2 = require('lodash'),
  merge = _require2.merge,
  pick = _require2.pick;
const evaluateSource = require('../lib/evaluateSource');
const _require3 = require('../lib/common'),
  flattenCollection = _require3.flattenCollection;
const latestStatusFromContent = content => {
  const _content$statusHistor = content.statusHistory,
    statusHistory = _content$statusHistor === void 0 ? null : _content$statusHistor;
  if (statusHistory === null) {
    return statusHistory;
  }
  const _Object$values$sort = Object.values(statusHistory)
    /* eslint-disable-next-line no-underscore-dangle */.sort((a, b) => new Date(b._created) - new Date(a._created)),
    _Object$values$sort2 = _slicedToArray(_Object$values$sort, 1),
    _Object$values$sort2$ = _Object$values$sort2[0],
    latestStatusHistory = _Object$values$sort2$ === void 0 ? {} : _Object$values$sort2$;
  return latestStatusHistory.status;
};
const getInfo = workItemLocations => flattenCollection(workItemLocations).map(pedigree => {
  const _pedigree = _slicedToArray(pedigree, 2),
    _pedigree$ = _pedigree[0],
    _pedigree$2 = _pedigree$ === void 0 ? {
      identifier: 'noWorkItem',
      title: 'No Work Item'
    } : _pedigree$,
    workItemIdentifier = _pedigree$2.identifier,
    workItemTitle = _pedigree$2.title,
    _pedigree$3 = _pedigree[1],
    _pedigree$4 = _pedigree$3 === void 0 ? {
      identifier: 'noLocation',
      title: 'No Location'
    } : _pedigree$3,
    locationIdentifier = _pedigree$4.identifier,
    locationTitle = _pedigree$4.title;
  return {
    identifier: [workItemIdentifier, locationIdentifier].join('_'),
    path: ['', 'appendix8', 'workItemLocation', workItemIdentifier, 'children', locationIdentifier].join('/'),
    // path: path.join('/', 'appendix8', 'workItemLocation', workItemIdentifier,
    //  'children', locationIdentifier),
    title: [workItemTitle, locationTitle].join(' / ')
  };
});
const getReports = async (workItemLocations, sortOrder, reportTypes, nativeFunctions) => {
  const content = {};
  const parentContentPath = '/';
  const transientContext = {};
  const jobSource = {
    type: 'getObjectValueBehavior',
    path: 'id',
    object: {
      type: 'jobReferenceBehavior'
    }
  };
  const jobID = await evaluateSource.evaluateSource(jobSource, content, parentContentPath, transientContext, nativeFunctions);
  const _Object$keys = Object.keys(sortOrder),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    sortOrderIdentifier = _Object$keys2[0];
  const paths = getInfo(workItemLocations).map(info => info.path);
  const reportsSource = {
    type: 'queryEntityBehavior',
    entityName: 'Report',
    properties: ['appCreated', 'content', 'reportType/name', 'reportNumber'],
    equals: {
      'job/id': jobID
    },
    equalsOneOf: {
      'reportType/identifier': reportTypes
    },
    ifContent: {
      atAnyPaths: paths
    },
    orderBy: [{
      property: 'appCreated',
      ascending: sortOrderIdentifier !== 'descending'
    }]
  };
  const reports = await evaluateSource.evaluateSource(reportsSource, content, parentContentPath, transientContext, nativeFunctions);
  return reports;
};

/**
  * @function evalute - evaluate navsea00932ExportBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const picked = pick(source, ['appendices', 'workItemLocations', 'grouping', 'sortOrder', 'reportTypes']);
  const evaluated = await evaluateSource.evaluateSources(picked, content, parentContentPath, transientContext, nativeFunctions);
  const _evaluated$appendices = evaluated.appendices,
    appendices = _evaluated$appendices === void 0 ? {} : _evaluated$appendices,
    _evaluated$workItemLo = evaluated.workItemLocations,
    workItemLocations = _evaluated$workItemLo === void 0 ? {} : _evaluated$workItemLo,
    _evaluated$grouping = evaluated.grouping,
    grouping = _evaluated$grouping === void 0 ? {} : _evaluated$grouping,
    _evaluated$sortOrder = evaluated.sortOrder,
    sortOrder = _evaluated$sortOrder === void 0 ? {} : _evaluated$sortOrder,
    _evaluated$reportType = evaluated.reportTypes,
    reportTypes = _evaluated$reportType === void 0 ? [] : _evaluated$reportType;
  const reports = await getReports(workItemLocations, sortOrder, reportTypes, nativeFunctions);

  // special-case appendix 8
  let appendix8Results = {};
  if (appendices.appendix8 !== undefined) {
    reports.forEach(report => {
      const _report$content = report.content,
        reportContentString = _report$content === void 0 ? '{}' : _report$content;
      const reportContent = JSON.parse(reportContentString);
      const _reportContent$append = reportContent.appendix8,
        _reportContent$append2 = _reportContent$append === void 0 ? {} : _reportContent$append,
        system = _reportContent$append2.system,
        workItemLocation = _reportContent$append2.workItemLocation;
      const systemOption = system === undefined ? {} : {
        [system.title]: system
      };
      appendix8Results = merge(appendix8Results, {
        system: systemOption,
        workItemLocation
      });
    });
  }
  // and remove from standard processing
  const _remove1 = appendices.appendix8,
    processAppendices = _objectWithoutProperties(appendices, _excluded);
  const _Object$keys3 = Object.keys(grouping),
    _Object$keys4 = _slicedToArray(_Object$keys3, 1),
    groupingIdentifier = _Object$keys4[0];
  const group1 = {};
  reports.forEach((report, index) => {
    const dateKey = report.appCreated,
      _report$content2 = report.content,
      reportContentString = _report$content2 === void 0 ? '{}' : _report$content2;
    const dateValue = {
      _created: index
    };
    const reportContent = JSON.parse(reportContentString);
    const latestStatus = latestStatusFromContent(reportContent);
    const reportAppendices = Object.keys(processAppendices).filter(appendix => hasContentValue(reportContent[appendix]));
    if (reportAppendices.length > 0) {
      const _reportContent$append3 = reportContent.appendix8,
        appendix8 = _reportContent$append3 === void 0 ? {} : _reportContent$append3;
      const _appendix8$workItemLo = appendix8.workItemLocation,
        workItemLocation = _appendix8$workItemLo === void 0 ? {} : _appendix8$workItemLo;
      const _getInfo = getInfo(workItemLocation),
        _getInfo2 = _slicedToArray(_getInfo, 1),
        workItemLocationInfo = _getInfo2[0];
      if (workItemLocationInfo === undefined) {
        return;
      }
      const locationPath = workItemLocationInfo.path,
        locationTitle = workItemLocationInfo.title,
        locationKey = workItemLocationInfo.identifier;

      // eslint-disable-next-line no-unused-vars
      const _ref = getContentValue(locationPath, reportContent) || {},
        _remove2 = _ref.system,
        locationValue = _objectWithoutProperties(_ref, _excluded2);
      reportAppendices.forEach(appendixKey => {
        const appendixValue = appendices[appendixKey];
        const groupingMaps = {
          appendixLocation: {
            // appendix, location, date
            key1: appendixKey,
            value1: appendixValue,
            key2: locationKey,
            value2: locationValue,
            key3: dateKey,
            value3: dateValue,
            titleComponents: {
              one: {
                text: appendixValue.fullTitle,
                _created: 1
              },
              two: {
                text: locationTitle,
                _created: 2
              },
              three: {
                date: dateKey,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          locationAppendix: {
            // location, appendix, date
            key1: locationKey,
            value1: locationValue,
            key2: appendixKey,
            value2: appendixValue,
            key3: dateKey,
            value3: dateValue,
            titleComponents: {
              one: {
                text: locationTitle,
                _created: 1
              },
              two: {
                text: appendixValue.fullTitle,
                _created: 2
              },
              three: {
                date: dateKey,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          appendix: {
            // appendix, date, location
            key1: appendixKey,
            value1: appendixValue,
            key2: dateKey,
            value2: dateValue,
            key3: locationKey,
            value3: locationValue,
            titleComponents: {
              one: {
                text: appendixValue.fullTitle,
                _created: 1
              },
              two: {
                date: dateKey,
                _created: 2
              },
              three: {
                text: locationTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          location: {
            // location, date, appendix
            key1: locationKey,
            value1: locationValue,
            key2: dateKey,
            value2: dateValue,
            key3: appendixKey,
            value3: appendixValue,
            titleComponents: {
              one: {
                text: locationTitle,
                _created: 1
              },
              two: {
                date: dateKey,
                _created: 2
              },
              three: {
                text: appendixValue.fullTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          },
          none: {
            // date, appendix, location
            key1: dateKey,
            value1: dateValue,
            key2: appendixKey,
            value2: appendixValue,
            key3: locationKey,
            value3: locationValue,
            titleComponents: {
              one: {
                date: dateKey,
                _created: 1
              },
              two: {
                text: appendixValue.fullTitle,
                _created: 2
              },
              three: {
                text: locationTitle,
                _created: 3
              },
              four: {
                text: latestStatus,
                _created: 4
              }
            }
          }
        };
        const _groupingMaps = groupingMaps[groupingIdentifier || 'none'],
          key1 = _groupingMaps.key1,
          value1 = _groupingMaps.value1,
          key2 = _groupingMaps.key2,
          value2 = _groupingMaps.value2,
          key3 = _groupingMaps.key3,
          value3 = _groupingMaps.value3,
          titleComponents = _groupingMaps.titleComponents;
        if (group1[key1] === undefined) {
          group1[key1] = _objectSpread(_objectSpread({}, value1), {}, {
            group2: {}
          });
        }
        if (group1[key1].group2[key2] === undefined) {
          group1[key1].group2[key2] = _objectSpread(_objectSpread({}, value2), {}, {
            group3: {}
          });
        }
        const itemContent = _objectSpread(_objectSpread({}, value3), {}, {
          titleComponents
        });
        itemContent[appendixKey] = reportContent[appendixKey];
        group1[key1].group2[key2].group3[key3] = itemContent;
      });
    }
  });
  return {
    group1,
    appendix8: appendix8Results
  };
};
module.exports = {
  evaluate
};